import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    paddingBottom: 20,
    flexDirection: 'column',
    '& .label' : {
      color: '#69738c',
      fontWeight: 'bold',
      marginBottom: 8
    },
    '& textarea': {
      resize: 'none',
      width: 'auto',
      padding: 8,
      flexGrow: 1,
      borderRadius: '4px',
      border: 'solid 1px #c2c7ca',
    },
    "& .instructions": {
      color: "#958e8e",
      fontSize: "11pt"
    }
  },
  premise: {
    marginTop: 35,
    "& .comments": {
      flexGrow: 1,
      display: 'flex'
    },
    "& .edit-premise.editing" : {
      display: 'none',
      flexDirection: 'column',
      marginTop: 25,
      "&.editing" : {
        display: 'flex',
      },
      "& > .footer": {
        display: 'flex',
        justifyContent: 'flex-end',
        "& > .button": {
          marginTop: 10,
        },
        "& > .save": {
          marginLeft: 15
        }
      }
    },
    "& .view-premise" : {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 25,
      "&.editing" : {
        display: 'none'
      },
      "& .header" : {
        display: 'flex',
        justifyContent: 'flex-end',
        height: 25,
        marginBottom: 10,
        "& .edit-icon": {
          color: '#2ca5ec',
          fontSize: '14pt',
          cursor: 'pointer',
          "&:hover": {
            transform: 'scale(1.1)'
          }
        }
      }
    }
  },
  answer: {
    marginTop: 35,
    "& .button": {
      marginTop: 20,
      height: 30
    },
    "& .phrases": {
      marginTop: 20,
      display: "flex",
      flexWrap: "wrap"
    },
    "& .phrase": {
      cursor: 'pointer',
      color: '#69738c',
      "&.blanked": {
        fontWeight: "bold"
      },
      "&:hover": {
        textDecoration: "underline"
      }
    },
    "& .joiner": {
      marginLeft: 7,
      marginRight: 7,
      cursor: 'pointer',
      "&:hover": {
        transform: "scale(1.2)"
      }
    }
  }
}))

export {useStyles as default}
